module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"buyQuota":"Покупка","interviews":"откликов","sms":"SMS","calls":"звонков","rules":"При покупке {type} они не сгорают в начале отчетного периода","quantity":"Количество","payable":"К оплате:"}}')
  delete Component.options._Ctor
}
